import { NavLink } from 'react-router-dom';

import { Link } from 'evee-ui-common/components/base';

import EveeProtectLink from 'widgets/layout/EveeProtectLink';
import { Faq } from 'widgets/home';

const RenterFaq = () => {
  const questions = [
    {
      question: 'Can I ask the host a question before making a booking?',
      answer:
        "If you want to contact a host, you'll have to submit a booking request first (this opens up a direct chat line where you can ask any questions you might have). You'll only be charged for the booking if the host confirms the trip.",
    },
    {
      question: 'This is my first time in an EV - what do I need to know?',
      answer:
        "When you pick up the car from the host, they'll go over all the main features with you. This handover is also a great opportunity to ask any questions you have about driving electric, e.g. 'how do I charge the car?'.",
    },
    {
      question: 'Can I get the car delivered?',
      answer:
        'Some hosts offer airport delivery (or delivery to a personal address) for an additional fee. Please check the vehicle listing page to see if the host delivers to your location.',
    },
    {
      question: 'Do I need to buy insurance?',
      answer: (
        <>
          All vehicles rented through evee have insurance included in the rental price, with
          variable damage liability depending on the vehicle type. You can choose to add on{' '}
          <EveeProtectLink /> to cover the damage liability if there is an accident, or for
          protection against things such as minor parking damage, wheel scrapes, and windscreen
          damage or replacements.
        </>
      ),
    },
    {
      question: 'What if I damage the car?',
      answer:
        "It is the renter's responsibility to report any damages to the host as soon as possible. evee will capture your refundable deposit for minor damages and charge the full damage liability amount for major accidents while we determine liability and repair costs. Any remaining balance will be refunded to you at the end of the assessment.",
    },
    {
      question: 'How do I add a driver to my booking?',
      answer: (
        <>
          All additional drivers must make an account on evee, upload their licence and complete our
          driver declaration via the{' '}
          <Link to="account/personal-info" component={NavLink} style={{ fontWeight: 'normal' }}>
            Personal info
          </Link>{' '}
          accounts page (otherwise they will not be covered by insurance).
        </>
      ),
    },
    {
      question: 'What are the requirements for electric car rentals in Australia?',
      answer: 'To rent an electric car with evee, you need a valid driver’s licence and a verified evee account. The licence can be Australian or international. A credit or debit card is required for payment and security purposes. Renters must meet the minimum age requirements and adhere to all local road rules as well as renting conditions set by the owner.',
    },
    {
      question: 'How can I find charging stations in Australia?',
      answer: (
        <>
          Finding charging stations across Australia is simple with tools like{' '}
          <Link href="https://www.plugshare.com/" target="_blank">
            PlugShare
          </Link>{' '}
          and Google Maps, which offer real-time locations and availability of nearby stations. evee also provides a “charging concierge” service, which offers personalised assistance for trip planning and charging recommendations.
        </>
      ),
    },
    {
      question: 'Is there a minimum age requirement to rent an electric car at evee?',
      answer: 'The minimum age requirement for renting depends on the vehicle type. For standard vehicles, renters must be 25 or older, while premium and performance vehicles require renters to be 30 or older. All renters must hold a full, unrestricted driver’s licence. Each listing specifies the age requirements, so review them carefully before booking.',
    },
    {
      question: 'What are the advantages of peer-to-peer EV rental in Australia?',
      answer: (
        <>
          Peer-to-peer rental through evee builds and supports a community of like-minded individuals who share a passion for sustainable driving. Think of us as an Airbnb for electric car rentals in Australia and New Zealand. We offer a more personable experience with a direct line to owners for immediate support. Renters also gain access to a broader range of electric car brands and models, something that’s often unavailable through traditional rental platforms. Plus, you can count on receiving the exact vehicle you reserved — no unwelcome, last-minute “swap-outs”.
        </>
      ),
    },
    {
      question: 'How do I book an electric car rental through evee?',
      answer: (
        <>
          <Link href="https://www.evee.com.au/pages/renting/" target="_blank">Booking an electric car</Link> rental through evee is simple. First, sign up or log in to your account, then search for available EVs in your location. Once you find a vehicle that suits your needs, check the rental details and requirements, then book the car directly through the platform. You’ll receive confirmation from the vehicle owner, and they will provide further instructions for pickup and drop-off.
        </>
      ),
    },
    {
      question: 'What is the environmental impact of driving an electric car?',
      answer: (
        <>
          Driving an electric vehicle significantly reduces your carbon footprint compared to traditional petrol or diesel cars. EVs produce zero tailpipe emissions and can be powered by renewable energy sources, further lowering their impact on the environment. By renting an electric car with evee, you're contributing to a more sustainable future and helping reduce air pollution in your community.
        </>
      ),
    },
  ];

  return <Faq questions={questions} />;
};

RenterFaq.propTypes = {};

RenterFaq.defaultProps = {};

export default RenterFaq;
